import React from "react";
import ModernTypesManager from "./ModernTypesManager";

const App = () => {
  return <ModernTypesManager />;
};

export default App;